module.exports = __webpack_public_path__ + "img/product_89.5da656d.webp";